import React from 'react';
import { Camera } from 'lucide-react';
import { useDarkMode } from '../darkmode/DarkModeContext';
import { useNavigate } from 'react-router-dom';

const Gallery = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  const galleryItems = [
    { id: 'profil', title: 'Foto Profil', image: 'image/Gallery/profil1.jpg', description: 'Profil perusahaan dan layanan kami' },
    { id: 'dokumentasi', title: 'Dokumentasi Instalasi', image: 'image/Gallery/instalasi.png', description: 'Proses instalasi jaringan profesional' },
    { id: 'tim', title: 'Tim Support', image: 'image/Gallery/profil7.jpg', description: 'Tim teknisi berpengalaman' },
    { id: 'kantor', title: 'Kantor', image: 'image/Gallery/profil2.jpg', description: 'Fasilitas kantor modern' }
  ];

  const handleImageClick = () => navigate('/gallery');

  return (
    <div
      className="py-16 bg-cover bg-center transition-colors duration-300"
      style={{
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className={`text-3xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Gallery</h2>
          <p className={`text-sm mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Foto Company Profile</p>
          <div className="w-16 h-1 bg-gradient-to-r from-[#1E9B4C] to-green-600 mx-auto rounded-full"></div>
        </div>

        {/* Main Photo */}
        <div className="mb-8">
          <div
            className={`card-base relative overflow-hidden cursor-pointer ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}
            onClick={handleImageClick}
          >
            <div className="relative aspect-video">
              <img src={galleryItems[0].image} alt="Foto Profile" className="w-full h-full object-cover" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent h-28"></div>
              <div className="absolute top-3 right-3">
                <Camera className="w-6 h-6 text-white/70" />
              </div>
              <div className="absolute bottom-3 left-4">
                <div className={`rounded-lg px-3 py-1.5 backdrop-blur-sm text-sm ${isDarkMode ? 'bg-gray-800/80 text-white' : 'bg-white/80 text-gray-900'}`}>
                  Foto Profil Perusahaan
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sub Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {galleryItems.slice(1).map((item) => (
            <div key={item.id} className="group cursor-pointer" onClick={handleImageClick}>
              <div className={`card-base overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div className="relative aspect-video overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <h3 className={`font-semibold text-sm mb-1 group-hover:text-[#1E9B4C] transition-colors ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    {item.title}
                  </h3>
                  <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <button onClick={handleImageClick} className="btn-primary inline-flex items-center gap-2">
            <Camera className="w-4 h-4" />
            Lihat Semua Foto
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
